/** Default Storage bucket (Firebase Console → Storage). */
export const FIREBASE_STORAGE_BUCKET = 'kinship-8dd5c.firebasestorage.app';

const LEGACY_STORAGE_BUCKETS = ['kinship-8dd5c.appspot.com'];

/**
 * Rewrites legacy download URLs to the current bucket hostname.
 * Firebase may return either format depending on project age and SDK version.
 */
export const normalizeFirebaseStorageUrl = (
  value?: string | null
): string | undefined => {
  if (!value || typeof value !== 'string') return value ?? undefined;

  let normalized = value;
  for (const legacyBucket of LEGACY_STORAGE_BUCKETS) {
    if (normalized.includes(legacyBucket)) {
      normalized = normalized.split(legacyBucket).join(FIREBASE_STORAGE_BUCKET);
    }
  }
  return normalized;
};

export const normalizeStringArray = (value?: string[]): string[] | undefined => {
  if (!Array.isArray(value)) return value;
  return value.map((item) => normalizeFirebaseStorageUrl(item) || item);
};
